export default __webpack_public_path__ + "static/media/Globe Life.6b6f2e42.svg";